// extracted by mini-css-extract-plugin
module.exports = {"datum":"styles_datum__NhRRI","headerContent":"styles_headerContent__rL29f","contentContainer":"styles_contentContainer__3EN1m"};